
function CupomParceiro(){
    return <>
    
    <h1>Cupom Parceiro</h1>
    </>
}
export default CupomParceiro;